An array of codes for the offered schedules for the position.

Currently, two codes are defined:

- `FullTime` indicates a full-time schedule.
- `PartTime` indicates a part-time schedule.

Omit this field for the `seekAnz` scheme.
